"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const categories = [{
  id: 1,
  name: "Các dự án Thiết kế - Thẩm tra",
  items: [{
    id: 101,
    title: 'Nhà điều hành bến xe Yên Sở',
    image: 'https://nucectd.com/wp-content/uploads/2026/06/Picture1.png?v=b0tb3ljshf7'
  }, {
    id: 102,
    title: 'Trung tâm văn hóa – thông tin – thể thao huyện Cát Hải',
    image: 'https://nucectd.com/wp-content/uploads/2026/06/Picture2.jpg?v=vye2pwuygb'
  }, {
    id: 103,
    title: 'Khu E nhà máy Luxshare ICT – KCN Vân Trung – huyện Việt Yên – tỉnh Bắc Giang',
    image: 'https://nucectd.com/wp-content/uploads/2026/06/Picture4.jpg?v=l8ck5t8xsa'
  }]
}, {
  id: 2,
  name: "Các dự án Thiết kế - Thi công, cung cấp sản phẩm",
  items: [{
    id: 201,
    title: 'Cổng quốc môn Gia Lai – Cửa khẩu Lệ Thanh ',
    image: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/Picture5.png'
  }, {
    id: 202,
    title: 'Biểu tượng thành phố Cẩm Phả - Đèo Bụt',
    image: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/Picture9.png'
  }]
}, {
  id: 3,
  name: 'Một Số Công Trình Tiêu Biểu Đã Triển Khai',
  items: [{
    id: 301,
    title: 'Dự án Công ty Cổ Phần KCN Tân Vũ – Hải Phòng',
    image: 'https://nucectd.com/wp-content/uploads/2026/06/Picture6.jpg?v=yfz6anc9ppl'
  }, {
    id: 302,
    title: 'Dự án nhà máy sản xuất keo, chất kết dính và sản phẩm làm từ nhựa OKURA INDUSTRIAL CO.,LTD',
    image: 'https://nucectd.com/wp-content/uploads/2026/06/Picture7.png?v=d01wte5gs9o'
  }, {
    id: 303,
    title: 'Công trình Nhà máy DRB Việt Nam 2',
    image: 'https://nucectd.com/wp-content/uploads/2026/06/Picture8.png?v=mvfceaj66cq'
  }]
}];
function ProjectsGrid() {
  return <div className="space-y-16">
      {categories.map((category, catIdx) => <React.Fragment key={category.id}>
          <div data-index={catIdx} className="space-y-8">
            <h3 className="font-bold text-primary border-l-4 border-primary pl-4 !text-3xl">
              {category.name}
            </h3>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
              {category.items.map((item, itemIdx) => <Card key={item.id} data-index={itemIdx} className="overflow-hidden border bg-card shadow-sm">
                  <AspectRatio ratio={4 / 3}>
                    <img src={item.image} data-wvc-srcset={`${item.image}-wvc-srcset`} data-wvc-sizes={`${item.image}-wvc-sizes`} alt={item.title} className="h-full w-full object-cover" loading="lazy" />
                  </AspectRatio>
                  <CardContent className="p-4 text-center">
                    <p className="font-semibold text-foreground">{item.title}</p>
                  </CardContent>
                </Card>)}
            </div>
          </div>
          {catIdx < categories.length - 1 && null}
        </React.Fragment>)}
    </div>;
}
export default function SolutionsAndTechnology() {
  return <section id="giải-pháp-công-nghệ" className="relative bg-white py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-diagonal-grid opacity-30 pointer-events-none" />
      <div className="absolute top-0 left-0 h-1 w-full bg-primary" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <div className="mb-4 flex items-center gap-2 text-primary">
              <span className="h-px w-8 bg-primary"></span>
              <span className="text-sm font-bold uppercase tracking-widest">Dự án & Công nghệ</span>
            </div>
            <h2 className="text-4xl font-bold tracking-tight text-primary md:text-5xl lg:text-6xl">
              Giải pháp <span className="text-primary">Đột phá</span>
            </h2>
            <p className="mt-6 text-lg text-muted-foreground">
              NUCETECH tiên phong trong việc áp dụng các công nghệ xây dựng tiên tiến, mang lại hiệu quả tối ưu và bền vững cho mọi công trình.
            </p>
          </div>
          
          <Link to="/SolutionsPage">
            <Button size="lg" variant="outline" className="group min-w-[160px] border-primary text-primary hover:bg-primary hover:text-primary-foreground">
              Tất cả dự án
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>

        <div className="rounded-xl bg-background p-8 md:p-12 shadow-xl">
          <ProjectsGrid />
        </div>
      </div>
    </section>;
}